import { warn } from 'console';

export const getPortalBaseUrl = () => {
    return process.env.BASE_PLATFORM_API_URL ?? 'https://portalv2.intellispatial.io';
};

export const getPortalAppBaseUrl = () => {
    return process.env.BASE_PLATFORM_APP_URL ?? 'https://portalv2.intellispatial.io';
};

export const getGeoApiBaseUrl = () => {
    return process.env.BASE_GEOSPATIAL_API_URL ?? 'https://portalv2.intellispatial.io';
};

export const MAGIC_LINK_PATH = '/magic-login';

export const ROLE = {
    ORG_USER: 'OrganisationUser',
    ORG_ADMIN: 'OrganisationAdmin',
    PLATFORM_ADMIN: 'PlatformAdmin'
} as const;

export const ADMIN_MENU = {
    ORG_DETAILS: 'details',
    ORG_CONTACTS: 'contacts',
    ORG_DOMAIN_NAMES: 'domains',
    ORG_AUTHENTICATION: 'authentication',
    ORG_SPATIAL_REF: 'spatref',
    DIR_USERS: 'users',
    DIR_USERGROUPS: 'groups',
    FLD_DETAILS: 'fld-details',
    FLD_MODELS: 'fld-models',
    FLD_PERMISSIONS: 'fld-permissions'
} as const;

export const ORG_RESOURCE_TYPE = {
    LOGO: 'logo',
    BRAND: 'brandmark'
} as const;

export const CESIUM_EVENT = {
    ERROR: 'CESIUM_EVENT.ERROR'
};

export const BASE_LAYER = {
    BING: 'Bing Maps Aerial',
    ESRI_STREET_MAP: 'ESRI World Street Map'
};

export const defaultViewerMessage = { text: 'Something went wrong' };

export const ALERT_MESSAGE = {
    REQUEST_FAILED_HEADING: 'Request Failed',
    SAVE_FAILED_HEADING: 'Save Failed',
    POI_SAVE_ERROR: ['Your changes could not be saved.', 'Try again in a moment.'],
    POI_CONFLICT_HEADING: 'Someone else changed this object',
    // Reloading the objects is enough - it re-fetches them and re-seeds the tokens the save is checked
    // against - so this no longer sends people off to reload the whole browser page.
    POI_SAVE_ERROR_412: [
        'Your changes were not saved, because someone else edited this object while you were working on it.',
        'Reload the objects to get their version, then make your change again.'
    ]
};

export const DISPLAY_LAYOUT = {
    GRID: 'Grid',
    LIST: 'List'
};

export const FILE_TYPES = {
    THREE_D_TILESET: '3D Tileset',
    PANO_TOUR: 'PanoTour',
    FILE: 'File',
    WEB_LINK: 'WebLink',
    IMAGERY: 'Imagery'
};

export const DOC_EXTENSION_ARRAY = ['txt', 'rtf', 'doc', 'docx'];

export const XLS_EXTENSION_ARRAY = ['xls', 'xlsx'];

export const IMAGE_EXTENSION_ARRAY = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'ico', 'svg'];

export const SUPPORTED_GENERIC_UPLOAD_FILE_EXTENSIONS = [
    '.pdf', '.docx', '.doc', '.xlsx', '.xls', '.pptx', '.csv', '.txt',
    '.jpg', '.jpeg', '.png', '.tif', '.tiff', '.ecw',
    '.dwg', '.dxf', '.obj', '.mtl',
    '.shp', '.prj', '.las', '.laz', '.e57', '.rcp', '.gis', '.kml', '.kmz',
    '.rvt', '.ifc', '.nwd',
    '.mp4', '.mov', '.mpeg', '.mpg',
    '.zip', '.7z'
];

